import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';

export const QuickLinks = [
    {
        title: 'Franchise',
        link: ''
    },
    {
        title: 'Gallery',
        link: ''
    },
    {
        title: 'Media',
        link: ''
    },
    {
        title: 'Academy',
        link: ''
    },
    {
        title: 'CSR',
        link: ''
    },
]


export const ProductsLinks = [
    {
        title: 'Organic fertilizers',
        link: '/products/organic-liquid-fertilizer'
    },
    {
        title: 'Construction Chemicals',
        link: '/products/concrete-bonding-powder'
    },
    {
        title: 'Regular Cleaning Agents',
        link: '/products/floor-cleaner'
    },
    {
        title: 'Custom Cleaning agent',
        link: '/products/rust-cleaner'
    },

]

export const socialLinks = [
    {
        icon: <FacebookIcon />,
        link: ''
    },
    {
        icon: <InstagramIcon />,
        link: ''
    },
    {
        icon: <TwitterIcon />,
        link: ''
    },
    {
        icon: <LinkedInIcon />,
        link: ''
    },
   
]